module.exports = __webpack_public_path__ + "img/ornament_set.3a640c5.svg";